import { CommonModule } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { UiKitModule } from '@serviceplan/ui-kit';
import { AnyType } from '@thehubz/shared/model';
import { timeout } from 'rxjs';

@Component({
  selector: 'wl-jackpot-modal',
  standalone: true,
  imports: [CommonModule, UiKitModule],
  templateUrl: './jackpot-modal.component.html',
  styleUrls: ['./jackpot-modal.component.scss'],
})
export class JackpotModalComponent implements OnInit {
  previewImageUrl = '';
  constructor(@Inject(MAT_DIALOG_DATA) public data: AnyType, public matDialogRef: MatDialogRef<JackpotModalComponent>, private httpClient: HttpClient) {}

  ngOnInit(): void {
    if (this.data.assetType === 'Video') {
      this.httpClient
        .get<{ presignedUrl: string }>(this.data.imageUrl)
        .pipe(timeout(60000))
        .subscribe((res) => (this.previewImageUrl = res.presignedUrl));
    }
  }

  onAcceptClick() {
    this.matDialogRef.close({
      accepted: true,
    });
  }

  onCancelClick() {
    this.matDialogRef.close({
      accepted: false,
    });
  }
}
